import { Navigate, Route, Routes, useLocation, Outlet } from 'react-router-dom';
import React from 'react';
import PropTypes from 'prop-types';
import HubView from '../pages/Hub';
import SweepDetailView from '../pages/SweepDetail/Container';
import SweepEnteredView from '../pages/Entered';
import { Callback } from '../pages/Auth';
import SweepLayout from '../components/SweepLayout';
import { BASE_PATH } from '../config';

export const ApplicationRoutes = () => {
    return (
        <Routes>
            <Route
                path="*"
                element={
                    <HandleDoubleSlash>
                        <Routes>
                            <Route path={BASE_PATH}>
                                <Route path="" element={<HubView />} />
                                <Route
                                    path="sweep/:sweepId"
                                    element={
                                        <SweepLayout>
                                            <Outlet />
                                        </SweepLayout>
                                    }
                                >
                                    <Route
                                        path=""
                                        element={
                                            <SweepDetailView
                                                OnEntered={
                                                    <Navigate
                                                        to="entered"
                                                        replace
                                                    />
                                                }
                                            />
                                        }
                                    />
                                    <Route
                                        path="entered"
                                        element={
                                            <SweepEnteredView
                                                OnLoggedOut={
                                                    <Navigate to="/" />
                                                }
                                            />
                                        }
                                    />
                                </Route>
                                <Route
                                    path="sso/loginuser"
                                    element={<Callback />}
                                />
                            </Route>
                            <Route
                                path="*"
                                element={<Navigate to={BASE_PATH} />}
                            />
                        </Routes>
                    </HandleDoubleSlash>
                }
            />
        </Routes>
    );
};

function HandleDoubleSlash({ children }) {
    /* 
        This is here to handle cases where urls have more than 1 leading /, 
        for example https://super6.skysports.com//league. 
        Without this, you'd get a 404. 
        This caused an issue with silent auth as detailed in https://iw-sbg.atlassian.net/browse/S6-3237 
    */
    const { pathname, search, hash } = useLocation();
    const regex = /\/\/+/g;
    if (pathname.match(regex)) {
        const cleanUrl = `${pathname.replace(regex, '/')}${search}${hash}`;
        return <Navigate to={cleanUrl} />;
    }

    return children;
}

HandleDoubleSlash.propTypes = {
    children: PropTypes.node.isRequired
};

export default ApplicationRoutes;
